export default function (change) {
  switch (change) {
    case "CreateUser":
      return "Crear usuario";
    case "UpdateUser":
      return "Actualizar usuario";
    case "DeleteUser":
      return "Eliminar usuario";
    case "ChangePassword":
      return "Cambiar contraseña";
    case "CreateAccessKey":
      return "Crear clave de acceso";
    case "DeleteAccessKey":
      return "Eliminar clave de acceso";
    case "UpdateAccessKey":
      return "Actualizar clave de acceso";
    case "UpdateLoginProfile":
      return "Actualizar perfil de inicio de sesión";
    case "CreateRole":
      return "Crear rol";
    case "UpdateRole":
      return "Actualizar rol";
    case "DeleteRole":
      return "Eliminar rol";
    case "CreateGroup":
      return "Crear grupo";
    case "UpdateGroup":
      return "Actualizar grupo";
    case "DeleteGroup":
      return "Eliminar grupo";
    case "AttachUserPolicy":
      return "Asociar política a usuario";
    case "DetachUserPolicy":
      return "Desasociar política de usuario";
    case "PutUserPolicy":
      return "Definir política de usuario";
    case "DeleteUserPolicy":
      return "Eliminar política de usuario";
    case "AttachRolePolicy":
      return "Asociar política a rol";
    case "DetachRolePolicy":
      return "Desasociar política de rol";
    case "PutRolePolicy":
      return "Definir política de rol";
    case "DeleteRolePolicy":
      return "Eliminar política de rol";
    case "AttachGroupPolicy":
      return "Asociar política a grupo";
    case "DetachGroupPolicy":
      return "Desasociar política de grupo";
    case "PutGroupPolicy":
      return "Definir política de grupo";
    case "DeleteGroupPolicy":
      return "Eliminar política de grupo";
    case "AddUserToGroup":
      return "Agregar usuario a grupo";
    case "RemoveUserFromGroup":
      return "Quitar usuario de grupo";
    case "CreateVirtualMFADevice":
      return "Crear dispositivo autenticación multifactor virtual";
    case "DeactivateMFADevice":
      return "Desactivar dispositivo autenticación multifactor";
    case "DeleteVirtualMFADevice":
      return "Eliminar dispositivo autenticación multifactor virtual";
    case "EnableMFADevice":
      return "Activar dispositivo autenticación multifactor";
    case "ResyncMFADevice":
      return "Resincronizar dispositivo autenticación multifactor";
    case "CreateSession":
      return "Crear sesión";
    case "DeleteSession":
      return "Eliminar sesión";
    case "consoleLogin":
      return "Login"
    
    case "added_role":
      return "Rol agregado";
    case "removed_role":
      return "Rol eliminado";
    case "SetIamPolicy":
      return "Establecer política IAM";
    
    default:
      return change;
  }
}